import { getStorage } from "firebase/storage";
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { firebaseConfig } from "./firebase.config";
import { getAnalytics, setAnalyticsCollectionEnabled } from "firebase/analytics";
import { getUserConsent } from "../components/auth/GetUserConsent";

export const Firebase = initializeApp(firebaseConfig);
export const auth = getAuth();
export const Providers = { google: new GoogleAuthProvider(), apple: new OAuthProvider('apple.com') };
export const Storage = getStorage(Firebase, firebaseConfig.storageBucket);

// Initialize Analytics with consent
const analytics = getAnalytics(Firebase);
const userConsent = getUserConsent();
setAnalyticsCollectionEnabled(analytics, userConsent);